export default "__VITE_ASSET__DgF48OvQ__";